export default {
    fields: [
        {value: 'id', label: '公司ID'},
        {value: 'company_name', label: '公司名称'},
        {value: 'software_types', label: '代账软件'},
        {value: 'fin_charges', label: '收费标准'},
        {value: 'leader_id', label: '财税负责人'},
        {value: 'acc_id', label: '理票会计'},
        {value: 'legal_name', label: '法定代表人'},
        {value: 'finance_user', label: '财务代表人'},
        {value: 'tax_scale', label: '纳税规模'},
        {value: 'server_status', label: '服务状态'},
        {value: 'is_ukey', label: '购买UKEY'},
        {value: 'is_invoice_bill', label: '购买发票'},
        {value: 'invoice_company', label: '开票单位'},
        {value: 'triple_agreement', label: '三方协议'},
        {value: 'back_bill_card', label: '回单卡'},
        {value: 'social_security', label: '社保'},
        {value: 'accumula_fund', label: '公积金'},
        {value: 'open_account', label: 'CA开户'},
        {value: 'advisory_id', label: '记账报税会计'},
        {value: 'general_account', label: '综合会计'},
        {value: 'ass_id', label: '客服会计'},
        {value: 'invoice_id', label: '开票会计'},
        {value: 'service_advisor_id', label: '财税顾问'},
        {value: 'sharers', label: '共享人'},
        {value: 'start_time', label: '服务周期开始'},
        {value: 'end_time', label: '服务周期结束'},
        {value: 'saler_id', label: '所属业务'},
        {value: 'customer_name', label: '用户姓名'},
        {value: 'customer_phone', label: '用户手机'},
        {value: 'is_auth', label: '是否阅读须知'},
        {value: 'subscribe', label: '是否关注公众号'},
        {value: 'remark', label: '备注信息'}
    ]
};



// WEBPACK FOOTER //
// ./src/lib/financeFields.js